import React, { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { isImageNotFound } from "../../hooks/use-convert-image-to-base-64";

// Logo / footer image on a paper-receipt preview. The paper prints nothing
// when there is no image, so a missing or unloadable image renders nothing,
// wrapper included (no not-found placeholder, unlike BoxImage).
// Accepts a picked File/Blob or a converted data URI; a raw upload key (still
// being fetched by the caller) renders nothing until it is converted.
export const ReceiptImage = ({ image, sx, imgStyle }) => {
  const [failed, setFailed] = useState(false);
  const src = useMemo(() => {
    if (image instanceof Blob) return URL.createObjectURL(image);
    if (
      typeof image === "string" &&
      image.startsWith("data:image") &&
      !isImageNotFound(image)
    ) {
      return image;
    }
    return null;
  }, [image]);

  useEffect(() => {
    setFailed(false);
    return () => {
      if (src && src.startsWith("blob:")) URL.revokeObjectURL(src);
    };
  }, [src]);

  if (!src || failed) return null;
  return (
    <Box align="center" sx={sx}>
      <img
        src={src}
        onError={() => setFailed(true)}
        alt={"receipt_image"}
        style={imgStyle}
      />
    </Box>
  );
};
